import * as React from "react";
import {
  Button,
  useNotify,
  useDataProvider,
  useRefresh,
  useRecordContext,
} from "react-admin";
import { useMutation } from "react-query";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";

const GridActionButton = ({
  label = "Dooo it!",
  url,
  method = "POST",
  successMessage = "Success!",
  confirm = false,
  confirmMessage = "Are you sure you want to perform this action?",
  getConfirmationText,
  onChange = () => null,
  ...props
}) => {
  const notify = useNotify();
  const dataProvider = useDataProvider();
  const refresh = useRefresh();
  const record = useRecordContext();

  const [open, setOpen] = React.useState(false);

  const mutator = () => {
    return dataProvider
      .customCommand(url, notify, method, successMessage)
      .then(() => {
        refresh();
        onChange();
      });
  };

  const { mutate, isLoading } = useMutation(mutator, {
    onError: (error) => {
      notify(error?.message || "Something went wrong", { type: "warning" });
    },
  });

  const handleClick = (event) => {
    event.stopPropagation();
    if (confirm) {
      setOpen(true);
    } else {
      mutate();
    }
  };

  const handleConfirm = () => {
    setOpen(false);
    mutate();
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const message =
    typeof getConfirmationText === "function"
      ? getConfirmationText(record)
      : confirmMessage;

  return (
    <>
      <Button
        label={isLoading ? "Processing..." : label}
        onClick={handleClick}
        color="inherit"
        size="small"
        disabled={isLoading}
        {...props}
      />

      {confirm && (
        <Dialog open={open} onClose={handleCancel}>
          <DialogTitle>Confirm Action</DialogTitle>
          <DialogContent>
            <DialogContentText>{message}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button label="Cancel" onClick={handleCancel} />
            <Button
              label="Confirm"
              onClick={handleConfirm}
              disabled={isLoading}
            />
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};

export default GridActionButton;
